// src/lib/utils.js
export function cn(...classes) {
    return classes.filter(Boolean).join(" ");
}

export function decodeHtmlEntities(value) {
    if (!value) return "";
    const el = document.createElement("textarea");
    el.innerHTML = value;
    return el.value;
}

